import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { WorkFormContext } from '../work-form.types';
import { DepartmentDetailResponse } from '../../../../api';

export const useWorkFormDepartmentLocation = (
  defaultValues: Partial<WorkFormContext> | undefined,
  departmentData: DepartmentDetailResponse | undefined
) => {
  const { setValue } = useFormContext<WorkFormContext>();
  useEffect(() => {
    const defaultsHaveNoLocation = !defaultValues?.location;
    const departmentHasLocation = !!departmentData?.department.location;
    const hasDepartmentChanged = departmentData?.department.id !== defaultValues?.department;

    if ((defaultsHaveNoLocation || hasDepartmentChanged) && departmentHasLocation) {
      setValue('location', departmentData.department.location, {
        shouldValidate: true,
      });
    } else if (defaultsHaveNoLocation && !departmentHasLocation) {
      setValue('location', null, {
        shouldValidate: true,
      });
    }
  }, [departmentData?.department.id, setValue]);
};
